import { registerInternalResource } from "../lib/internal-resources";
import { auditTrailResourceConfig } from "./audit-trail.config";
import { chatThreadResourceConfig } from "./chat-thread.config";
import { dataImportJobResourceConfig } from "./data-import-job.config";
import { emailLogResourceConfig } from "./email-log.config";
import { employeeInvitationResourceConfig } from "./employee-invitation.config";
import { llmAuditLogResourceConfig } from "./llm-audit-log.config";
import { outboundLogResourceConfig } from "./outbound-log.config";
import { supportToolLogResourceConfig } from "./support-tool-log.config";
import { workflowRunResourceConfig } from "./workflow-run.config";

registerInternalResource(auditTrailResourceConfig);
registerInternalResource(chatThreadResourceConfig);
registerInternalResource(dataImportJobResourceConfig);
registerInternalResource(emailLogResourceConfig);
registerInternalResource(employeeInvitationResourceConfig);
registerInternalResource(llmAuditLogResourceConfig);
registerInternalResource(outboundLogResourceConfig);
registerInternalResource(workflowRunResourceConfig);
registerInternalResource(supportToolLogResourceConfig);

export {
  auditTrailResourceConfig,
  chatThreadResourceConfig,
  dataImportJobResourceConfig,
  emailLogResourceConfig,
  employeeInvitationResourceConfig,
  llmAuditLogResourceConfig,
  outboundLogResourceConfig,
  supportToolLogResourceConfig,
  workflowRunResourceConfig,
};
